type TipoImovel = 'casa' | 'sobrado' | 'predio' | 'loja' | 'galpao' | 'praca' | 'padaria' | 'varandas' | 'escritorio';

/** Small independent SVG lots keep their proportions across the full viewport. */
function Lote({ tipo, indice }: { tipo: TipoImovel; indice: number }) {
  if (tipo === 'praca') return (
    <svg className="lp__bairro-lote" viewBox="20 0 100 120" preserveAspectRatio="xMidYMax meet" fill="none">
      <g transform="translate(8.4 12.36) scale(.88)" className="lp__bairro-casa">
        <path d="M17 94Q50 78 114 93L111 102H19Z" fill="#5c7852" />
        <path d="M61 88Q74 94 69 107" stroke="#a7ae91" strokeWidth="7" />
        <g className="lp__bairro-arvore">
          <path d="M33 94V57M33 73 22 63M33 68 42 58" stroke="#ae9874" strokeWidth="3" />
          <circle cx="24" cy="57" r="13" fill="#74925c" /><circle cx="39" cy="50" r="16" fill="#89a36b" /><circle cx="43" cy="64" r="12" fill="#658757" />
        </g>
        <g className="lp__bairro-arvore">
          <path d="M100 90V65" stroke="#aa9976" strokeWidth="2.5" />
          <path d="M100 40 88 74H112Z" fill="#729076" /><path d="M100 40V74H112Z" fill="#547c62" />
        </g>
        <path d="M43 89 61 94M43 85 61 90" stroke="#c69d72" strokeWidth="3" /><path d="M45 89V96M59 93V99" stroke="#263e33" strokeWidth="2" />
        <path d="M80 96V57H86" stroke="#91a18c" strokeWidth="2" /><path className="lp__bairro-janela" d="M82 57h8l-2 5h-4Z" />
        <circle cx="22" cy="98" r="2" fill="#e1b083" /><circle cx="28" cy="99" r="2" fill="#dbcc9c" /><circle cx="109" cy="96" r="2" fill="#e1b083" />
      </g>
    </svg>
  );
  const altura = { casa: 35, sobrado: 54, predio: 76, loja: 31, galpao: 39, padaria: 31, varandas: 64, escritorio: 59 }[tipo];
  const topo = 90 - altura;
  const corBase = { casa: '#d9ccb0', sobrado: '#b3cfbf', predio: '#a9c3d0', loja: '#e0bca7', galpao: '#b9c2b7', padaria: '#e6c796', varandas: '#cfb7a7', escritorio: '#99b9be' }[tipo];
  const cor = indice > 8 ? ['#c4b899', '#c3a899', '#9fb8b0', '#b9c3a3'][indice % 4] : corBase;
  const telhado = tipo === 'casa' || tipo === 'sobrado';
  const andares = tipo === 'predio' ? 4 : tipo === 'varandas' ? 3 : tipo === 'sobrado' ? 2 : 1;
  return (
    <svg className="lp__bairro-lote" viewBox="20 0 100 120" preserveAspectRatio="xMidYMax meet" fill="none">
      <g transform="translate(8.4 12.36) scale(.88)">
      <g className="lp__bairro-casa" data-bairro-imovel>
        <path d="M30 90 75 102 103 88 119 94 87 107 30 94Z" fill="#132d21" opacity=".38" />
        <path d="M54 95 65 98 62 108 48 108Z" fill="#a1ac92" />
        <path d={telhado
          ? `M30 ${topo - 0.8} 48 ${topo - 17.2} 75 ${topo + 10.7}V102L30 90Z`
          : `M30 ${topo} 75 ${topo + 12}V102L30 90Z`} fill={cor} />
        <path d={`M75 ${topo + 12} 103 ${topo - 2}V88L75 102Z`} fill={cor} />
        <path d={`M75 ${topo + 12} 103 ${topo - 2}V88L75 102Z`} fill="#183d39" opacity=".28" />
        {indice % 4 === 0 && <>
          <path d="M16 89V66L32 70V93Z" fill="#8b9e8c" />
          <path d="M14 66 22 62 35 66 32 71Z" fill="#b8c4af" />
          <path className="lp__bairro-janela" d="M20 73l7 2v8l-7-2Z" />
        </>}
        {telhado ? <>
          <path d={`M26 ${topo + 1} 48 ${topo - 19} 80 ${topo + 14}V${topo + 16}L48 ${topo - 17} 26 ${topo + 3}Z`} fill="#866958" />
          <path d={`M48 ${topo - 19} 76 ${topo - 33} 108 ${topo} 80 ${topo + 14}Z`} fill={tipo === 'casa' ? '#b78369' : '#668baa'} />
        </> : <>
          <path d={`M28 ${topo} 58 ${topo - 15} 106 ${topo - 2} 75 ${topo + 14}Z`} fill="#d0d8cc" />
          <path d={`M35 ${topo - 1} 58 ${topo - 12} 97 ${topo - 2} 75 ${topo + 9}Z`} fill={tipo === 'predio' ? '#7e98a1' : '#7b8f83'} />
          {tipo === 'predio' && <path d={`M53 ${topo - 6} 64 ${topo - 11} 77 ${topo - 8}V${topo - 3}L66 ${topo + 2} 53 ${topo - 1}Z`} fill="#bdc9c7" />}
        </>}
        {tipo === 'galpao' ? <>
          <path d="M39 66 68 74V99L39 91Z" fill="#6d8885" />
          {[72, 78, 84, 90].map(y => <path key={y} d={`M40 ${y} 67 ${y + 7}`} stroke="#a9bcaf" strokeWidth="1.5" />)}
          <path className="lp__bairro-janela" d="M81 62 96 55V66L81 73Z" />
        </> : tipo === 'escritorio' ? <>
          <path className="lp__bairro-janela" d="M35 39 70 48V93L35 84ZM80 47 98 38V81L80 90Z" />
          {[54, 68, 82].map(y => <path key={y} d={`M35 ${y}l35 9M80 ${y + 8}l18-9`} stroke="#c3d3cc" strokeWidth="2" />)}
          <path d="M52 44V89M89 43V86" stroke="#c3d3cc" strokeWidth="2" />
        </> : tipo === 'loja' || tipo === 'padaria' ? <>
          <path className="lp__bairro-janela" d="M36 73 68 81V98L36 90Z" />
          <path d="M52 77V94" stroke="#d0d9cf" strokeWidth="2" />
          <path d="M26 69 74 82 79 74 31 61Z" fill="#d5b58c" />
          {[0, 1, 2, 3].map(i => <path key={i} d={`M${31 + i * 12} ${61 + i * 3.25}l6 1.6-5 8-6-1.6Z`} fill={tipo === 'padaria' ? '#977451' : '#a8614c'} />)}
          <path className="lp__bairro-janela" d="M82 75 96 68V83L82 90Z" />
          {tipo === 'padaria' && <>
            <path d="M41 56 65 62V72L41 66Z" fill="#775a40" />
            <path d="M46 62q2-5 12 2q3 5-3 3Z" fill="#edcc90" />
            <path d="M49 61l1 3m3-2 1 3" stroke="#9e784e" />
          </>}
        </> : <>
          {Array.from({ length: andares }, (_, row) => [0, 1].map(col => {
            const x = 38 + col * 19;
            const y = topo + 11 + col * 5 + row * 15;
            return <path key={`${row}-${col}`} className="lp__bairro-janela" d={`M${x} ${y}l10 2.7v8l-10-2.7Z`} />;
          }))}
          {Array.from({ length: andares }, (_, row) => <path key={row} className="lp__bairro-janela" d={`M82 ${topo + 14 + row * 15}l13-6v8l-13 6Z`} />)}
          {tipo === 'varandas' && [48, 65].map(y => <g key={y}>
            <path d={`M33 ${y}l40 11 7-4-40-11Z`} fill="#eadbc4" />
            <path d={`M33 ${y}v6l40 11v-6M40 ${y + 2}v6M52 ${y + 5}v6M64 ${y + 8}v6`} stroke="#858f82" strokeWidth="1.5" />
            <path d={`M36 ${y + 3}l10 3v3l-10-3Z`} fill="#729363" />
          </g>)}
          <path d="M54 82 63 84.5V99L54 96.5Z" fill="#36564c" />
        </>}
        {telhado && indice % 2 === 0 && <>
          <path d={`M61 ${topo - 20}l13-6 18 18-13 6Z`} fill="#426577" stroke="#9bb6bd" strokeWidth=".8" />
          <path d={`M68 ${topo - 23}l18 18m-19-9 13-6`} stroke="#9bb6bd" strokeWidth=".7" />
        </>}
        <path d="M30 88.5 75 100.5 103 86.5V89L75 103 30 91Z" fill="#667665" />
        <path d="M30 91 75 103 103 89" stroke="#1e392a" strokeWidth="1.4" />
        {indice % 4 === 2 && <g>
          <path d="M108 100V75h13M119 76v24" stroke="#8fa394" strokeWidth="2" />
          <path d="M105 74h19l-2-4h-15Z" fill="#b8c4b0" />
          <path d="M110 79h7v12h-7Z" fill="#b0c9bc" opacity=".7" />
          <path d="M109 96h11" stroke="#c1a886" strokeWidth="2" />
        </g>}
        {indice % 4 !== 2 && <>
        <ellipse cx="118" cy="96" rx="7" ry="2" fill="#213c2c" opacity=".4" />
        <g className="lp__bairro-arvore">
          <path d="M118 95V75" stroke="#aa9976" strokeWidth="2.5" />
          {indice % 3 === 0 ? <>
            <path d="M118 50 108 79h20Z" fill="#698968" /><path d="M118 50v29h10Z" fill="#547659" />
          </> : <>
          <ellipse cx="118" cy="70" rx="9" ry={indice % 2 ? 15 : 11} fill="#6d9270" />
          <ellipse cx="115" cy="67" rx="5" ry="8" fill="#a4bb80" opacity=".45" />
          </>}
        </g>
        </>}
        {indice % 3 === 1 && <g stroke="#9cafa1" strokeWidth="1.3"><circle cx="17" cy="99" r="4" /><circle cx="29" cy="99" r="4" /><path d="M17 99l5-7 7 7H17l3-9m5 1h4" /></g>}
        {indice % 3 === 0 && <g>
          <circle cx="24" cy="93" r="1.8" fill="#d5bd9d" />
          <path d="M24 96v5m-2 3 2-3 2 3" stroke="#bdb9a0" strokeWidth="1.6" strokeLinecap="round" />
          <path d="M21 97h5" stroke="#bdb9a0" strokeWidth="1.5" />
        </g>}
      </g>
      </g>
    </svg>
  );
}

export function BairroRodape() {
  const tipos: TipoImovel[] = ['casa', 'varandas', 'padaria', 'sobrado', 'escritorio', 'loja', 'predio', 'praca', 'galpao', 'sobrado', 'varandas', 'casa', 'loja', 'escritorio', 'predio', 'sobrado', 'galpao', 'casa', 'varandas', 'loja'];
  return (
    <div className="lp__bairro lp__bairro--panorama" aria-hidden="true">
      {tipos.map((tipo, indice) => <Lote key={indice} tipo={tipo} indice={indice} />)}
      <svg className="lp__bairro-inquilino-modelo" viewBox="0 0 12 20" fill="none">
        <circle cx="6" cy="3" r="2.3" fill="#e8bf98" />
        <path d="M6 7v6" stroke="#e6b974" strokeWidth="4" strokeLinecap="round" />
        <path className="lp__inquilino-braco" d="M6 8l-3 5" stroke="#e8bf98" strokeWidth="1.8" strokeLinecap="round" />
        <path className="lp__inquilino-perna" d="M6 13l-3 5" stroke="#d6dfd0" strokeWidth="2" strokeLinecap="round" />
        <path className="lp__inquilino-perna lp__inquilino-perna--oposta" d="M6 13l3 5" stroke="#afc6be" strokeWidth="2" strokeLinecap="round" />
      </svg>
      <div className="lp__bairro-trafego">
        {['#cfdee0', '#d6b58b', '#9fbfb2'].map((cor) => (
          <svg key={cor} className="lp__bairro-veiculo" viewBox="0 0 40 20" fill="none">
            <ellipse cx="19" cy="17" rx="18" ry="3" fill="#10261d" opacity=".5" />
            <path d="M3 11 10 3H25L33 11V16H3Z" fill={cor} />
            <path d="M11 4H24L29 10H6Z" fill="#426e7b" />
            <path d="M17 4V10" stroke={cor} strokeWidth="2" />
            <rect x="1" y="10" width="35" height="6" rx="2" fill={cor} />
            <circle cx="9" cy="16" r="3" fill="#102a21" /><circle cx="28" cy="16" r="3" fill="#102a21" />
            <path d="M34 12H39" stroke="#ffe3a6" strokeWidth="2" />
          </svg>
        ))}
      </div>
    </div>
  );
}
